import { Fragment } from "react";
const ExplanationBox = (props) => {
    const { title, text, top = -68 } = props

    return (
        <Fragment>
            <div className="left-triangle">
                <div />
            </div>
            <div className="explanation-box" style={{ top: top }}>
                <p className="font-size-11 margin-bottom-12 padding-left-8 padding-right-8 padding-top-15 line-height-150">{title}</p>
                <div className="explanation-line" />
                <p className="font-size-11 margin-bottom-0 padding-left-8 padding-right-8 padding-top-5 line-height-150 padding-bottom-14 pre-line">
                    {text}
                </p>
            </div>
        </Fragment>
    )

}

export default ExplanationBox;
